function makeComponentEntryEnvelopeFromComponentEnvelope(user, componentEnvelope) {
  return {
    componentID: componentEnvelope.ID,
    componentType: componentEnvelope.Type,
    created: Math.round(Date.now() / 1000),
    modified: Math.round(Date.now() / 1000),
    userID: user?.id ?? "guest",
    productID: componentEnvelope.Owner.ProductID,
    readOnly: false,
    shared: false,
    result: null,
    title: componentEnvelope.Title
  };
}

export { makeComponentEntryEnvelopeFromComponentEnvelope };
//# sourceMappingURL=util.make-component-entry-envelope.js.map
